import React, { useEffect, useState, useCallback, useRef } from "react";

import SummaryApi from "../../common/SummaryApi";
import api from "../../common/apiClient";

const monthNames = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

const SalesChart = () => {
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [maxValue, setMaxValue] = useState(0);
  const [activeIndex, setActiveIndex] = useState(null);
  const chartRef = useRef(null);

    const fetchRevenue = useCallback(async () => {
    try {
        setLoading(true);

        const res = await api({
        ...SummaryApi.dashboardRevenue
        });

        if (res.data.success) {
        const revenueMap = res.data.revenue.data || {};
        const today = new Date();

        const result = [];
        for (let i = 11; i >= 0; i--) {
            const d = new Date(today.getFullYear(), today.getMonth() - i, 1);
            const monthName = monthNames[d.getMonth()];
            const year = d.getFullYear();

            result.push({
            month: monthName,
            year,
            label: `${monthName}-${year}`,
            value: revenueMap[monthName] || 0,
            isCurrent:
                d.getMonth() === today.getMonth() &&
                d.getFullYear() === today.getFullYear()
            });
        }

        const values = result.map(r => r.value);
        const maxValue = Math.max(...values);
        const minValue = Math.min(...values);
        const roundedMax = Math.ceil(maxValue / 1000) * 1000;
        setMaxValue(roundedMax);


        const colored = result.map(item => {
            let color = "bg-black";

            if (item.value === maxValue && maxValue !== minValue) {
            color = "bg-[#007BFF]";
            } else if (item.value === minValue && maxValue !== minValue) {
            color = "bg-red-500";
            } else if (item.isCurrent) {
            color = "bg-blue-500";
            }

            return { ...item, color };
        });

        setChartData(colored.reverse());
        }
    } catch (err) {
        console.error("Revenue fetch error:", err);
    } finally {
        setLoading(false);
    }
    }, []); // ✅ no deps because nothing external is used


    useEffect(() => {
    fetchRevenue();
    }, [fetchRevenue]);

const yAxisSteps = 3; // 0, 1/3, 2/3, max
const stepValue = Math.ceil(maxValue / yAxisSteps);

useEffect(() => {
  const handleClickOutside = (event) => {
    if (chartRef.current && !chartRef.current.contains(event.target)) {
      setActiveIndex(null);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);


  return (
    <div className="bg-[#F8FAFC] rounded-2xl p-5 w-full"
      ref={chartRef}>
      <h3 className="text-sm font-semibold text-gray-800 mb-4">
        Sales (Last 12 Months)
      </h3>

      {loading ? (
        <p className="text-xs text-gray-400">Loading chart...</p>
      ) : (
        <div className="flex h-[180px]">
          <div className="flex flex-col justify-between text-[10px] text-gray-400 pr-3 pb-4">
            {[...Array(yAxisSteps + 1)].map((_, i) => {
            const value = stepValue * (yAxisSteps - i);
            return (
                <span key={i}>
                {value === 0 ? "0" : `${Math.round(value / 1000)}K`}
                </span>
            );
            })}
       </div>
        <div className="flex items-end gap-3 h-[180px]
                  overflow-x-auto sm:overflow-visible
                  px-1 w-full">
          {chartData.map((item, index) => (
            <div
            key={index}
            className="flex flex-col items-center flex-1"
            >
            {activeIndex === index && (
                <span className="mb-1 text-[11px] font-semibold text-gray-700">
                ₹{item.value.toLocaleString()}
                </span>
            )}

            <div
                className={`w-4 md:w-5 rounded-md transition-all ${item.color} cursor-pointer`}
                onClick={() =>
                setActiveIndex(activeIndex === index ? null : index)
                }
                style={{
                height: maxValue
                    ? `${Math.max((item.value / maxValue) * 160, 4)}px`
                    : "4px"
                }}
            />

            <span className="mt-2 text-[10px] text-gray-500 whitespace-nowrap">
                {item.label}
            </span>
            </div>

          ))}
        </div>
        </div>
      )}
    </div>
  );
};

export default SalesChart;
